import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface PropTypes {
  title?: string;
  subtitle?: string;
  image?: string;
}

function Headline(props: PropTypes): JSX.Element {
  return (
    <Box>
      <Typography variant="h2" align={'center'} fontWeight={700} gutterBottom>
        {props.title}
      </Typography>
      <Typography variant="h6" align={'center'} color={'textSecondary'}>
        {props.subtitle}
      </Typography>
    </Box>
  );
}

export default Headline;
